import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

// 라이브러리 등록
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

// 참고
// https://www.chartjs.org/
// https://velog.io/@whiteme06/React.js-Typescript-Chart.js-%EC%82%AC%EC%9A%A9%ED%95%98%EA%B8%B0
//https://velog.io/@dev_0livia/React%EB%A1%9C-%EC%B0%A8%ED%8A%B8-%EA%B7%B8%EB%A6%AC%EA%B8%B0-ft.-Chart.js-Recharts
// https://www.chartjs.org/docs/latest/configuration/responsive.html

interface DataArr {
  graphData?: string[] | number[];
  ymax?: number;
}

/** 선 그래프 */
export const LineGraph = (props: DataArr) => {
  const graphData = props.graphData || new Array(31).fill(0);

  const ymax = props.ymax || 700;
  const color = "#EB003B";

  const labels = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  ];

  const data = {
    labels,
    datasets: [
      {
        data: graphData,
        borderColor: color,
        backgroundColor: color,
        tichks: {
          hover: "none",
          color: color,
        },
      },
    ],
  };
  const options = {
    responsive: true,
    scales: {
      x: {
        border: {
          display: false,
        },
        grid: {
          display: false, // x축 그리드
        },
        ticks: { color: "#C6C6C6" },
      },
      y: {
        min: 0,
        // max: ymax,
        border: {
          display: false,
        },
        grid: {
          display: false, // y축 그리드
        },
        ticks: {
          color: "#C6C6C6",
          precision: 0, // 소수점 없이 정수만 표시
        },
      },
    },
    plugins: {
      legend: {
        display: false, // 범례표시
      },
    },
  };

  return <Line options={options} data={data} />;
};
